const mapQuickSearchSelectors = function() {
  const self = {};

  const _select = function(state) {
    return state.map.quickSearch;
  };

  self.selectPin = function(state) {
    const root = _select(state);

    return root.pin;
  };

  self.selectResults = function(state) {
    const root = _select(state);

    return root.results;
  };

  self.selectIsLoading = function(state) {
    const root = _select(state);

    return root.isLoading;
  };

  self.selectQuery = function(state) {
    const root = _select(state);

    return root.query;
  };

  return self;
};

export default mapQuickSearchSelectors();
